import { NivelAprobacion } from "./NivelAprobacion";

export class NivelDelegado{
    otorgadoPor: string;
    fechaDesde: string;
    fechaHasta: string;
    codigoNivelAprobacion: string;
    detalle: string;
}
